<table
  class="comp table-striped compSize borderless"
  width="100%"
  cellspacing="0"
  border="0"
>
  <thead>
    <tr>
      <th></th>
    </tr>
    <tr>
      <th></th>
    </tr>
    <tr class="overall-row">
      <th class="overall-title-col">
        <div>
          <span class="overall-title">
            {{ district["officialSchoolName"]?.title }}
          </span>
          <span class="goal-title">{{
            district["officialSchoolName"]?.goalTitle
          }}</span>
        </div>
      </th>
    </tr>
  </thead>
</table>
